import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const store = new Vuex.Store({
  // 初始化的数据
  state: {
    formDatas: null,
    token: "1",
    refresh_token: "",
    showLogin: false,
    isActive: 0,
    showLoginBox: false,

    loginShow: false,
    loginMode: 1,
    loginPath: "/",
  },
  // 改变state里面的值得方法
  mutations: {
    getFormData(state, data) {
      state.formDatas = data;
    },
    saveToken(state, data) {
      state.token = data;
      window.localStorage.setItem("Token", data);// 就是这里，保存到了 localStorage 中
    },
    saveOrgInfo(state, data) {
      state.OrgInfo = data;
      window.localStorage.setItem("OrgInfo", data);
    },
    setRefreshToken(state, data) {
      state.refresh_token = data
    },
    removeRefreshToken(state) {
      state.refresh_token = ""
    },
    setLoginShow(state, val) {
      state.loginShow = val;
    },
    setLoginMode(state, val) { state.loginMode = val; },
    setLoginPath(state, val) { state.loginPath = val ? val : "/"; },
  },
  actions: {
    setToken(context, param) {
      context.commit('setToken', param)
    },
    setRefreshToken(context, param) {
      context.commit('setRefreshToken', param)
    },
    removeRefreshToken(context) {
      context.commit('removeRefreshToken')
    },
    showLogin(context) {
      context.commit('setLoginShow', false);
    },
    hideLogin(context) {
      context.commit('setLoginShow', true);
    },
  },
  getters: {
    getToken(state) {
      return state.token
    },
    getRefreshToken(state) {
      return state.refresh_token
    }
  }
});
// 输出模块
export default store;



// WEBPACK FOOTER //
// ./src/store/index.js